import api from './client';

export interface BugReportPayload {
  category?: string;
  description: string;
  page_url?: string;
  user_agent?: string;
  screenshot_url?: string;
  contact?: string;
}

export interface BugReportResponse {
  id: number;
  category: string;
  created_at: string;
  message: string;
}

export const feedbackAPI = {
  async submit(payload: BugReportPayload): Promise<BugReportResponse> {
    const { data } = await api.post<BugReportResponse>('/api/feedback/report', payload);
    return data;
  },
  async uploadScreenshot(file: File): Promise<{ url: string }> {
    const formData = new FormData();
    formData.append('file', file);
    const { data } = await api.post<{ url: string }>('/api/feedback/upload', formData);
    return data;
  },
};

